export const getElevation = (raisedProp: boolean, variantProp?: string): number => {
    if (raisedProp) {
        return 5;
    } else if (variantProp === 'outlined') {
        return 0;
    }

    return 1;
};
